import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { CuestionariosService } from '../services/cuestionarios.service';

@Component({
  selector: 'app-renumerar-pregunta-dialog',
  templateUrl: './renumerar-pregunta-dialog.component.html',
  providers: [MessageService]
})
export class RenumerarPreguntaDialogComponent implements OnInit, OnChanges {
  @Input() displayDialog: boolean = false;
  @Input() preguntaSeleccionada: any = null;
  @Input() cuestionario: any = null;
  @Output() displayDialogChange = new EventEmitter<boolean>();
  @Output() onHide = new EventEmitter<{refresh: boolean}>();

  form: FormGroup;
  loading: boolean = false;

  constructor(
    private fb: FormBuilder,
    private messageService: MessageService,
    private cuestionariosService: CuestionariosService
  ) {
    this.form = this.fb.group({
      origen: [{ value: '', disabled: true }, Validators.required],
      destino: ['', [Validators.required, Validators.min(1)]]
    });
  }

  ngOnInit(): void {
    this.cargarDatosPregunta();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['preguntaSeleccionada'] && this.preguntaSeleccionada) {
      this.cargarDatosPregunta();
    }
  }

  cargarDatosPregunta(): void {
    if (this.preguntaSeleccionada) {
      this.form.patchValue({
        origen: this.preguntaSeleccionada.iNumPreg
      });
    }
  }

  onSubmit(): void {
    if (this.form.valid) {
      this.loading = true;
      const formValue = this.form.getRawValue();
      
      const request = {
        que: 6, // Para renumerar
        sClaveCues: this.cuestionario.sClaveCues,
        iNumPreg: this.preguntaSeleccionada.iNumPreg,
        sQuePregunta: formValue.destino.toString(),
        sTabla: "",
        sTipo: "",
        sCampo: "",
        iTipoResp: 0,
        bActualizar: 0,
        bMostrar: 0,
        bGrabar: 0,
        iNumPregNuevo: parseInt(formValue.destino)
      };

      this.cuestionariosService.guardarPregunta(request).subscribe({
        next: (response) => {
          if (response.success && response.data.error === 0) {
            this.messageService.add({
              severity: 'success',
              summary: 'Éxito',
              detail: 'Pregunta renumerada correctamente'
            });
            this.onDialogClosed();
            this.onHide.emit({ refresh: true });
          } else {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'No se pudo renumerar la pregunta'
            });
          }
        },
        error: (error) => {
          console.error('Error:', error);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'No se pudo renumerar la pregunta'
          });
        },
        complete: () => {
          this.loading = false;
        }
      });
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Por favor complete todos los campos requeridos'
      });
    }
  }

  onDialogClosed(): void {
    this.displayDialog = false;
    this.displayDialogChange.emit(this.displayDialog);
    this.onHide.emit({ refresh: false });
  }
} 